import {
  CARAVAN_DETAILS_STEP,
  CARAVAN_INTRO_STEP,
  CARAVAN_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Caravan";

import { FormState } from "Store/priceCalculation/priceCalculationInterfaces";
import { mapInjuriesToForm } from "Store/priceCalculation/productMappers/common/injuriesMapper";
import { booleanToFormBoolean } from "Utils/formUtils";
import { DEDUCTIBLE_FOUR_THOUSAND } from "Utils/priceUtils";
import { DEFAULT_DEDUCTIBLE_CARAVAN } from "../constants";

export const mapFromCommerceCaravan = (
  data: Record<string, any>,
): FormState => {
  const deductibleCode = String(data.priceSpecifications.deductible.code);

  return {
    [CARAVAN_INTRO_STEP.id]: {
      brand: data.brand,
      model: data.model,
      registrationYear: String(data.registrationYear),
    },
    [CARAVAN_DETAILS_STEP.id]: {
      coverageAmount: data.coverageAmount,
      fixedPlace: booleanToFormBoolean(data.permanentPlace),
      ...mapInjuriesToForm(data.damageCountRecentYears, data.yearOfLastDamage),
    },
    [CARAVAN_PRICE_STEP.id]: {
      movables: String(data.movables),
      deductible:
        deductibleCode === DEDUCTIBLE_FOUR_THOUSAND
          ? DEFAULT_DEDUCTIBLE_CARAVAN
          : deductibleCode,
      coverage: data.coverageGroup,
    },
  };
};
